import type { SVGProps } from "react";

export function IconBlackListPerson(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M21 6.5C21 8.433 19.433 10 17.5 10C15.567 10 14 8.433 14 6.5C14 4.567 15.567 3 17.5 3C19.433 3 21 4.567 21 6.5Z"
        fill="#0B0C17"
      />
      <path d="M12 14V20H23V14H12Z" fill="#0B0C17" />
      <path
        d="M21 6.5C21 8.433 19.433 10 17.5 10C15.567 10 14 8.433 14 6.5C14 4.567 15.567 3 17.5 3C19.433 3 21 4.567 21 6.5Z"
        stroke="#0B0C17"
        strokeWidth="1.5"
      />
      <path d="M12 14V20H23V14H12Z" stroke="#0B0C17" strokeWidth="1.5" />
      <path
        d="M9 7H1M7 12H1M7 17H1"
        stroke="#0B0C17"
        strokeWidth="1.5"
        strokeLinecap="square"
      />
    </svg>
  );
}
